import AvailabilitiesPreview from "../pages-admin/UserPreview/AvailabilitiesPreview";

const AvailabilitiesGraphApp =
  ({ schedules }, rails) =>
  () =>
    <AvailabilitiesPreview schedules={schedules} />;

export default AvailabilitiesGraphApp;
